import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { 
	getRegisteredUsersChart
} from "../../../../redux/dashboard/dashboardState";
import CardItem from "components/card/CardItem";
import BarChart from "components/charts/BarChart";
import AddressFilter from "components/search/AddressFilter";
import { MdBarChart } from "react-icons/md";
import { Modal } from "antd";
import ModalSearchFilter from "components/search/ModalSearchFilter";

const RegisteredUsersChart = ({getChartData, graphData, requesting, success, error, filters, ...props}) => {
  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);

  useEffect(() => {
      getChartData(filters);
  }, [getChartData]);

  const isLoading = requesting && !success;
  const hasError = error && !requesting;

  const applyFilter = (filters) => {
    closeModal();
    getChartData(filters);
  }

  const resetFilter = () => {
    closeModal();
    getChartData(null);
  }
  
  return (
    <CardItem extra="pb-7 p-[20px]"
      icon={<MdBarChart className="h-6 w-6 text-theme-500 dark:text-theme-400"/>}
      title={"User Registration Trend"}
      cardMenu={
        <button 
          onClick={openModal}
          className="card-menu-button">
        Filter
        </button>
      }
    >

      <div className="h-[250px] w-full pt-0 pb-0">
      {isLoading ? (
          <p className="text-gray-500 text-sm">Loading chart...</p>
        ) : hasError ? (
          <p className="text-red-500 text-sm">Failed to load chart data.</p>
        ) : (
          <BarChart
            series={graphData.series}
            options={graphData.options}
          />
        )}
      </div>
      <ModalSearchFilter 
        className="form-column-2" 
        isModalVisible={isModalVisible}
        closeModal={closeModal}
        filterHandler={applyFilter}
        resetHandler={resetFilter}
        title="Apply Filters"/>
    </CardItem>
  );
};

const mapStateToProps = (state) => ({
    requesting: state.dashboard.registeredUsersChart?.requesting,
    success: state.dashboard.registeredUsersChart?.success,
    error: state.dashboard.registeredUsersChart?.error,
    graphData: state.dashboard.registeredUsersChart?.chartData,
    filters: state.dashboard.registeredUsersChart?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  getChartData: (filters) => dispatch(getRegisteredUsersChart(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisteredUsersChart);
